__webpack_require__.p = "https://bmidxbirelandplpreprod.netlify.app/";